// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"368":"25d60050","612":"9daca2c2","818":"3e377a8c","900":"a64e1415"}[chunkId] + ".js";
};